import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { QcsLoadingButton } from '../common/basic/QcsLoadingButton';
import { InvitationCreateForm } from '../../models/invitation';

export const InvitationButton: FC = () => {
  const { t } = useTranslation();
  const { isSubmitting, submitForm } = useFormikContext<InvitationCreateForm>();

  return (
    <QcsLoadingButton variant="contained" color="primary" disabled={isSubmitting} loading={isSubmitting} onClick={submitForm}>
      {t('common.send')}
    </QcsLoadingButton>
  );
};
